import { makeStyles } from '@material-ui/core/styles';

const userStylesPageStaff = makeStyles(() => ({
  '@global': {
    'body': {
      backgroundColor: 'white',
      minHeight: 'unset',
    },
  },
  contentWrap: {
    position: 'absolute',
    width: '100%',
    top: '64px',
    height: 'calc(100% - 64px)',
    display: 'flex',
    padding: '8px 16px 0px',
  },
  head: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '120px',
    '& .MuiTabs-flexContainer': {
      justifyContent: 'center'
    }
  },
  select: {
    width: '232px',
    color: '#828282',
    fontSize: '20px',
    height: '40px',
    marginRight: '24px',
  },
  input: {
    padding: '5px',
    width: '200px',
    height: '40px',
    marginRight: '14px',
    color: '#828282',
    size: '20px',
  },
  tableHead: {
    backgroundColor: '#DADADA',
  },

  tableCell: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#4F4F4F',
    whiteSpace: 'nowrap'
  },
  tableCellDetail: {
    fontSize: '20px',
    fontWeight: 400,
    color: '#4F4F4F',
  },
  tableCellImage: {
    fontSize: '16px',
    color: '#828282',
    textDecorationLine: 'underline',
  },
  menuImage: {
    margin: '0 auto',
  },
  button: {
    borderRadius: '28px',
    textAlign: 'center',
    padding: '5px 32px',
    margin: '5px',
    whiteSpace: 'nowrap',
    '@media (max-width: 400px)' : {
      padding: '5px 10px',
    },
  },
  buttonUpdate: {
    background: '#FFA04B',
    color: '#FFFFFF',
    '&:hover': {
      background: '#FFA04B',
    },
  },
  buttonDelete: {
    background: '#828282',
    color: '#FFFFFF',
    '&:hover': {
      background: '#828282',
    },
  },
  buttonDetailOrder: {
    background: '#FFA04B',
    color: '#FFFFFF',
    '&:hover': {
      background: '#FFA04B',
    },
    textDecoration: 'none',
    fontWeight: '500',
    fontSize: '15px',
    height: '34px',
    borderRadius: '28px',
    textAlign: 'center',
    padding: '9px 32px',
  },
  buttonController: {
    color: '#fff',
    borderRadius: '28px',
    padding: '12px 0',
    fontSize: '18px',
    width: '252px',
    textAlign: 'center',
  },
  buttonAdd: {
    background: '#FFA04B',
    '&:hover': {
      background: '#FFA04B',
    },
  },
  buttonBack: {
    background: '#828282',
    '&:hover': {
      background: '#828282',
    },
  },
  search: {
    cursor: 'pointer',
  },
  headerActions: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '15px',
  },
  headerTitle: {
    paddingRight: '10px',
  },
  table: {
    minWidth: 650,
  },
  rootDate: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '5px',
    padding: '6px',
    height: '40px',
    color: '#828282',
    marginRight: '10px',
  },
  centerModal: {
    minHeight: '360px',
    maxHeight: '420px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  customTab: {
    marginTop: '10px',
    marginBottom: '10px',
    color: '#FFA04B',
    border: '1px solid #FFA04B',
    fontWeight: 600,
    minWidth: 100,
    minHeight: 'auto',
    boxShadow:
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    '@media (max-width: 1366px)': {
      minWidth: 80,
    },    
  },
  customTabLeft: {
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
    '&.Mui-selected': {
      background: '#FFA04B',
      color: '#FFFFFF',
      border: '1px solid #FFA04B',
    },
  },
  customTabRight: {
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    '&.Mui-selected': {
      background: '#FFA04B',
      color: '#FFFFFF',
      border: '1px solid #FFA04B',
    },
  },
  avatar: {
    minWidth: 80
  },
  description: {
    minWidth: 200,
    maxWidth: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  textCenter: {
    textAlign: 'center',
    '@media (max-width: 500px)' : {
      textAlign: 'left'
    },
  },
  addChipMenuButton: {
    maxHeight: 80,
    minWidth: 80,
    maxWidth: 80,
    '& .MuiButton-label': {
      transform: 'translateY(-5px)',
      '@media (max-width: 375px)' : {
        transform: 'translateY(0px)'
      },
    }
  },
  textArea: {
    minHeight: 100,
    maxHeight: 101,
    border: '1px solid #0000003b',
    borderRadius: 4,
    marginTop: 8,
    resize: 'none',
    padding: '0px 14px',
    overflow: 'auto !important',
    fontSize: '21px !important'
  },
  priceItem: {
    color: '#4F4F4F',
    fontSize: '18px',
    fontWeight: 600,
    textAlign: 'right'
  },
  deleteMenuChip: {
    position: 'absolute',
    fontSize: 22,
    top: -5,
    fontWeight: 600,
    right: 5,
    cursor: 'pointer',
    textAlign: 'right',
    width: 25
  },
  wrapperChipMenu: {
    marginTop: 24
  },
  left: {
    fontSize: '18px',
    color: '#000',
    fontWeight: 400,
  },
  right: {
    fontSize: '24px',
    color: '#4F4F4F',
    fontWeight: 700,
  },
  buttonHeader: {
    textAlign: 'center',
    color: '#fff',
    fontSize: '18px',
    background: '#F2C94C',
    padding: '8px 20px',
    borderRadius: '28px',
    width: '220px',
    '&:hover': {
      background: '#F2C94C',
    },
  },
  contentDetail: {
    color: '#000000',
    fontSize: '18px',
    fontWeight: 400,
  },
  inputModalStaff: {
    width: '100%',
    color: '#4F4F4F',
    fontSize: '24px',
    height: '48px',
    borderRadius: '4px',
  },
  avatarModalStaff: {
    width: 200,
    height: 200,
    border: '1px solid #0000003b',
    cursor: 'pointer',
  },
  scrollContent: {
    '@media (max-width: 500px)' : {
      overflowX: 'scroll'
    },
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center'
  },
  cardContent: {
    overflowX: 'hidden',
    '@media (max-width: 375px)' : {
      maxHeight: '63vh',
      minHeight: '350px'
    }
  },
  wrapMenuChip: {
    transform: 'translateX(-20px)',
    '@media (max-width: 500px)' : {
      transform: 'translateX(0)'
    },
  },
  cardContentStaff: {
    '@media (max-width: 375px)' : {
      maxHeight: '52vh',
      minHeight: '350px'
    }
  }
}));

export { userStylesPageStaff  };
